var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.378 12.01c0-6.627 5.374-12 12-12 6.627 0 12 5.373 12 12s-5.373 12-12 12c-6.626 0-12-5.373-12-12Zm12.73-10.423v9.64h6.826v1.553h-8.385V1.595c-5.378.423-9.618 4.93-9.618 10.415 0 5.764 4.683 10.448 10.447 10.448 5.765 0 10.448-4.683 10.448-10.448 0-5.519-4.299-10.047-9.718-10.423Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Clock.dacab4088aa5495989421d748a364349.svg";